(function () {
  var isTouch = window.matchMedia('(hover: none)').matches;

  document.addEventListener('click', function (e) {
    if (!isTouch) return;

    var a = e.target.closest('.artist-logos-grid .menu-swap');
    if (!a) return;

    // Premier tap : on bloque la navigation et on affiche l’aperçu
    if (!a.classList.contains('peek')) {
      e.preventDefault();
      a.classList.add('peek');
      a.setAttribute('aria-pressed', 'true');

      // On retire l’aperçu automatiquement au bout d’1,5 s
      setTimeout(function () {
        a.classList.remove('peek');
        a.removeAttribute('aria-pressed');
      }, 1500);
    }
    // Deuxième tap pendant la fenêtre : on laisse naviguer
  }, { capture: true });
})();
